export default __webpack_public_path__ + "static/media/turquoise-right.2429ad85.svg";